import React from 'react';
import { Box, Button, Card, Typography } from '@mui/material';
import { CollectionClientNote } from '../model';
import { SectionLabel } from './clientDetailPresentation';

const formatNoteTimestamp = (iso: string): string =>
  new Date(iso).toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });

interface Props {
  notes: CollectionClientNote[];
  onViewAll: () => void;
}

const ClientRecentNotesCard: React.FC<Props> = ({ notes, onViewAll }) => {
  const previewNotes = notes.slice(0, 5);
  return (
    <Card sx={{ p: 2, height: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <SectionLabel>Recent Notes (Last 5 notes)</SectionLabel>
        <Button size="small" onClick={onViewAll}>
          View all / Add note
        </Button>
      </Box>
      {previewNotes.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No notes yet.
        </Typography>
      ) : (
        previewNotes.map((note) => (
          <Box key={note.id} sx={{ mb: 1 }}>
            <Typography variant="caption" color="primary">
              {formatNoteTimestamp(note.display_at)} ·{' '}
              {note.imported_from_servman ? note.added_by || 'Servman' : note.user_name || 'System'}
            </Typography>
            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
              {note.body}
            </Typography>
          </Box>
        ))
      )}
    </Card>
  );
};

export default ClientRecentNotesCard;
